import { Button, ButtonProps } from '../../molecules';
import Arrow from './Arrow';
import Calendar from './Calendar';
import Chevron from './Chevron';
import Clock from './Clock';
import Email from './Email';
import Exit from './Exit';
import Eyes from './Eyes';
import Globe from './Globe';
import LocationPin from './LocationPin';
import MousePointer from './MousePointer';
import Plus from './Plus';
import QuestionMark from './QuestionMark';
import Video from './Video';

import { IconProps } from './types';

export type AvailableIcons = keyof typeof icons;

const icons = {
    arrowLeft: (props: IconProps) => <Arrow direction="left" {...props} />,
    arrowRight: (props: IconProps) => <Arrow direction="right" {...props} />,
    arrowUp: (props: IconProps) => <Arrow direction="up" {...props} />,
    arrowDown: (props: IconProps) => <Arrow direction="down" {...props} />,
    chevronLeft: (props: IconProps) => <Chevron direction="left" {...props} />,
    chevronRight: (props: IconProps) => (
        <Chevron direction="right" {...props} />
    ),
    chevronUp: (props: IconProps) => <Chevron direction="up" {...props} />,
    chevronDown: (props: IconProps) => <Chevron direction="down" {...props} />,
    exit: Exit,
    location: LocationPin,
    calendar: Calendar,
    video: Video,
    email: Email,
    clock: Clock,
    globe: Globe,
    plus: Plus,
    questionMark: QuestionMark,
    mousePointer: MousePointer,
    eyes: Eyes,
};

const Icon = ({
    name,
    className,
    strokeWidth = 1.5,
}: IconProps & { name: AvailableIcons }): JSX.Element | null => {
    if (name in icons) {
        return icons[name]({ className, strokeWidth });
    }
    return null;
};

export const IconButton = ({
    name,
    strokeWidth = 1.5,
    ariaLabel,
    onClick,
    variant,
}: IconProps & {
    name: AvailableIcons;
    onClick: ButtonProps['onClick'];
    ariaLabel: string;
    variant?: ButtonProps['variant'];
}): JSX.Element => {
    return (
        <Button
            type="button"
            variant={variant || 'primary'}
            onClick={onClick}
            ariaLabel={ariaLabel}
        >
            <Icon name={name} strokeWidth={strokeWidth} />
        </Button>
    );
};

export default Icon;
